import React, { FC } from 'react';

import { Spinner } from '@rbilabs/universal-components';

import { IServerOrder } from '@rbi-ctg/menu';
import { ServiceMode } from 'generated/graphql-gateway';
import { OrderStatus } from 'state/order/types';

import ConfirmPickup from './confirm-pickup';
import DeliveryConfirmation from './delivery/delivery-confirmation';
import PickupConfirmed from './pickup-confirmed';

interface IOrderConfirmationContentProps {
  loading: boolean;
  serverOrder: IServerOrder | null;
}

export const OrderConfirmationPageContent: FC<React.PropsWithChildren<
  IOrderConfirmationContentProps
>> = (props: IOrderConfirmationContentProps) => {
  const { loading, serverOrder } = props;

  if (!serverOrder) {
    return <Spinner marginTop={'50%'} />;
  }

  const {
    cart: { serviceMode },
    status: orderStatus,
  } = serverOrder;

  if (loading) {
    return <ConfirmPickup serverOrder={serverOrder} />;
  }

  if (serviceMode === ServiceMode.DELIVERY) {
    return <DeliveryConfirmation serverOrder={serverOrder} />;
  }

  switch (orderStatus) {
    case OrderStatus.INSERT_REQUESTED:
    case OrderStatus.PAYMENT_REQUESTED:
    case OrderStatus.PAYMENT_REQUIRED:
    case OrderStatus.PAYMENT_SUCCESSFUL:
    case OrderStatus.PRICE_SUCCESSFUL:
    case OrderStatus.VALIDATION_ERROR:
      return <ConfirmPickup serverOrder={serverOrder} />;
    case OrderStatus.INSERT_SUCCESSFUL:
    case OrderStatus.UPDATE_REQUESTED:
    case OrderStatus.UPDATE_ERROR:
    case OrderStatus.UPDATE_SUCCESSFUL:
      return <PickupConfirmed serverOrder={serverOrder} />;
    default:
      return <Spinner marginTop={'50%'} />;
  }
};
